export default __webpack_public_path__ + "media/images/navigate_plus_v2-059b5ac4779efb1a13ef7f6fb1a2a566.png";